export default __webpack_public_path__ + "static/media/about1.4bff6d60.png";